import { SITE_URL, SITE_NAME, FAVICON_URL, SITE_LANGUAGES } from "./site";

export interface ArticleSchemaInput {
  title: string;
  description: string;
  image: string;
  url: string;
  datePublished: string;
  dateModified: string;
  author: string;
  language: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: FAVICON_URL,
  };
}

export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    inLanguage: SITE_LANGUAGES,
    publisher: organizationSchema(),
  };
}

export function articleSchema(input: ArticleSchemaInput) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: input.title,
    description: input.description,
    image: input.image,
    url: input.url,
    mainEntityOfPage: input.url,
    datePublished: input.datePublished,
    dateModified: input.dateModified,
    inLanguage: input.language,
    author: {
      "@type": "Organization",
      name: input.author,
    },
    publisher: organizationSchema(),
  };
}

export function breadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function faqSchema(items: FaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
}

let managedSchemaIds: string[] = [];

export function clearSchemas() {
  managedSchemaIds.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.remove();
  });
  managedSchemaIds = [];
}

export function applySchemas(schemas: { id: string; data: Record<string, unknown> }[]) {
  clearSchemas();
  schemas.forEach(({ id, data }) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
    managedSchemaIds.push(id);
  });
}